import React from 'react';
import ReactMarkdown from 'react-markdown';

const ChatMessageContent = ({ content }) => {
  if (!content) return null;

  return (
    <div data-testid="chat-message-content" className="chat-md-content">
      <ReactMarkdown
        components={{
          h1: ({ children }) => <h1 className="chat-md-h1">{children}</h1>,
          h2: ({ children }) => <h2 className="chat-md-h2">{children}</h2>,
          h3: ({ children }) => <h3 className="chat-md-h3">{children}</h3>,
          h4: ({ children }) => <h4 className="chat-md-h4">{children}</h4>,
          p: ({ children }) => <p className="chat-md-p">{children}</p>,
          strong: ({ children }) => <strong className="chat-md-bold">{children}</strong>,
          em: ({ children }) => <em className="chat-md-italic">{children}</em>,
          del: ({ children }) => <del className="chat-md-strike">{children}</del>,
          ul: ({ children }) => <ul className="chat-md-ul">{children}</ul>,
          ol: ({ children }) => <ol className="chat-md-ol">{children}</ol>,
          li: ({ children }) => <li className="chat-md-li">{children}</li>,
          hr: () => <hr className="chat-md-hr" />,
          blockquote: ({ children }) => <blockquote className="chat-md-blockquote">{children}</blockquote>,
          a: ({ href, children }) => (
            <a href={href} target="_blank" rel="noopener noreferrer" className="chat-md-link">
              {children}
            </a>
          ),
          img: ({ src, alt }) => (
            <div className="chat-md-img-wrap">
              <img
                src={src}
                alt={alt || 'Travel image'}
                className="chat-md-img"
                loading="lazy"
                onError={(e) => { e.target.style.display = 'none'; }}
              />
              {alt && alt !== 'Image' && <span className="chat-md-img-caption">{alt}</span>}
            </div>
          ),
          code: ({ inline, children }) =>
            inline ? (
              <code className="chat-md-code-inline">{children}</code>
            ) : (
              <pre className="chat-md-code-block"><code>{children}</code></pre>
            ),
          table: ({ children }) => (
            <div className="chat-md-table-wrap">
              <table className="chat-md-table">{children}</table>
            </div>
          ),
          th: ({ children }) => <th className="chat-md-th">{children}</th>,
          td: ({ children }) => <td className="chat-md-td">{children}</td>,
        }}
      >
        {content}
      </ReactMarkdown>
    </div>
  );
};

export default ChatMessageContent;
